import React from 'react';

export const DropDownIcon = (props) => (
    <svg {...props} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 7.75L0.75 1.5L1.625 0.625L7 6L12.375 0.625L13.25 1.5L7 7.75Z" fill="#9A9EA6" />
    </svg>
);

